class FailedToLoadBackOfficeDynamically extends Error {
    constructor(cause?: Error) {
        super("Dynamic import of back office failed", { cause });
    }
}

export { FailedToLoadBackOfficeDynamically };
